import _ from 'lodash';
import React from 'react';
import dayjs from 'dayjs';

// Material UI
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import DeleteIcon from '@material-ui/icons/Delete';

import { useCommunicationTypeLabel } from '../../EmailLog/EmailLogList/email-log-list.utils';

interface IAssessmentSessionNotificationsList {
  notifications: {type: string; scheduledAt: Date; sentAt?: Date}[];
  cancelNotification?: Function;
}

export const AssessmentSessionNotificationsList: React.FC<IAssessmentSessionNotificationsList> = ({ notifications, cancelNotification }) => {
  const communicationTypeLabel = useCommunicationTypeLabel()

  return <List>
    {_.map(notifications, ({scheduledAt, sentAt, type}) => {
      const date = sentAt ?? scheduledAt
      return (
        <ListItem key={date.toString()}>
          <ListItemText primary={communicationTypeLabel(type)} secondary={dayjs(new Date(date)).format('YYYY/MM/DD @ h:mm A')} />
          {!sentAt && !!cancelNotification &&
            <ListItemSecondaryAction>
              <IconButton onClick={() => cancelNotification(date)}>
                <DeleteIcon />
              </IconButton>
            </ListItemSecondaryAction>
          }
        </ListItem>
      )
    })}
  </List>;
};
